import { useTranslation } from 'react-i18next';
import { Badge, focusRing, Tooltip } from '../../ui';
import type { DisplayRole } from './rules';

/** My role beside the avatars (backlog §19 P16-3.3), with what it allows in a tooltip; reachable by keyboard. */
export function RoleChip({ role }: { role: DisplayRole }) {
  const { t } = useTranslation();
  const name = t(`members.roles.${role}`);
  const rights = t(`members.rights.${role}`);
  return (
    <Tooltip label={rights} side="bottom">
      {/* Focusable so the tooltip opens from the keyboard too. */}
      <span tabIndex={0} aria-label={t('members.yourRole', { role: name, rights })} className={`rounded-full ${focusRing}`}>
        <Badge>{name}</Badge>
      </span>
    </Tooltip>
  );
}
